import React from "react";
import Link from "next/link";
import classNames from "classnames";
import { RouteStatusBadges } from "@src/routes/monitoring/components/RemoteLiveRouteListItem/components/RouteStatusBadges";
import { RoutesAttentionRoute } from "./types";

interface RoutesAttentionListProps {
  routes: RoutesAttentionRoute[];
  routesPageHref: string;
}

export function RoutesAttentionList({
  routes,
  routesPageHref,
}: RoutesAttentionListProps) {
  return (
    <ul className="divide-y divide-amber-200/70 dark:divide-amber-800/40 border-t border-amber-200/70 dark:border-amber-800/40">
      {routes.map((route) => (
        <li key={route.id}>
          <Link
            href={routesPageHref}
            className="grid grid-cols-[minmax(0,1fr),auto] items-center gap-x-4 px-4 py-2 text-xs hover:bg-amber-100/60 dark:hover:bg-amber-900/30"
          >
            <span className="flex items-center gap-2 min-w-0">
              <span className="font-semibold text-gray-900 dark:text-gray-100 truncate">
                #{route.routeTemplate.displayId} {route.routeTemplate.name}
              </span>
              <RouteStatusBadges statuses={route.statusList} />
            </span>
            <span
              className={classNames("truncate text-right", {
                "text-gray-600 dark:text-gray-300": route.driver,
                "text-amber-700 dark:text-amber-300": !route.driver,
              })}
            >
              {route.driver?.fullName ?? "Unassigned"}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
